import * as React from 'react';
import { DataGrid, ColDef, ValueGetterParams } from '@material-ui/data-grid';

interface TableProps {
  columns: ColDef[],
  rows: any[],
  check?: boolean,
  disableMulti?: undefined | true,
  handleClick?: ((row: any) => void),
  handleSelected?: ((row: any) => void),
}


const DataTable: React.FC<TableProps> = ({ columns, rows, check, handleClick, handleSelected, disableMulti }) => {


  return (
    <DataGrid
      rows={rows}
      columns={columns}
      pageSize={100}
      rowHeight={30}
      checkboxSelection={check}
      filterMode="client"
      autoHeight
      disableMultipleSelection={disableMulti}
      onRowClick={(e) => e}
      // sortingOrder={['desc']}
      // sortModel='id'
      onRowSelected={(row) => {
        if (handleClick !== undefined)
          handleClick(row)
      }}
      onSelectionChange={(rows) => {
        if (handleSelected !== undefined)
          handleSelected(rows.rowIds)
      }}
    />

  );
}

export default DataTable
